import { PaymentStatus } from '@prisma/client';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PaymentStatusState {
  status: PaymentStatus | null;
}

const initialState: PaymentStatusState = {
  status: null
};

const paymentStatusSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    setPaymentStatus: (state, action: PayloadAction<PaymentStatus>) => {
      state.status = action.payload;
    },
    clearPaymentStatus(state) {
      state.status = null;
    }
  }
});

export const { setPaymentStatus, clearPaymentStatus } =
  paymentStatusSlice.actions;
export default paymentStatusSlice.reducer;
